<template>
  <div class="room-menu-component" :class="{ hide: !isOpenExtendMenu }">
    <div :style="{
            backgroundColor: ux.menuColorId || '#5599ff'
          }"
         class="room-menu"
    >
      <div class="room-menu-header">
        <div class="setting">
          <img class="absolute pointer-events-none"
               :style="ux.logoImagePath ? {
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  inset: 0
               } : {
                 width: '34px',
                 height: 'auto'
               }"
               :src="ux.logoImagePath || require('@/assets/images/logo_gooroomee_white.svg')"
          />
          <button class="setting-button"
                  v-tooltip.right="$t('menu.setting')"
                  @click="onToggleSettingModal()"
          />
        </div>
      </div>
      <div class="room-menu-body">
        <div class="timer"
             @click="e => {
                let now = Date.now();
                if(now - (e.target._last_time || 0) > 2000){
                  e.target._cnt = 0;
                }
                e.target._last_time = now;
                e.target._cnt++;
                if(e.target._cnt >= 5){
                  e.target._cnt = 0;
                  toggleConnectionStats({
                    window: e.shiftKey
                  });
                }
              }"
        >
          <span ref="roomTimer" class="timer-text"></span>
        </div>
        <ul class="room-menu-list">
          <li class="room-menu-item"><button class="room-menu-button"
                                             :class="{
                                               selected: roomMode === 'call',
                                               disabled: isRoomModeExam || !isOpener() && isParticipantRole(),
                                             }"
                                             v-tooltip.right="$t('common.call')"
                                             @click="onClickMenu('call')">
            <GrmIcon icon="menu-call-white" size="full" />
          </button>
          </li>
          <li v-if="useScreenShare"
              class="room-menu-item">
            <button class="room-menu-button"
                  :class="{
                    selected: isRoomMode('screenShare'),
                    disabled: isRoomModeExam || (isWebinarLive && !hasSpeakerRole()) || !screenShareRole || Device.isMobile() || Device.isTablet() }
                  "
                  v-tooltip.right="screenShareTooltipMsg"
                    @click="onClickMenu('screenShare')"
            >
              <GrmIcon icon="menu-screenshare-white" size="full" />
            </button>
          </li>
          <li v-if="useDocShare"
              class="room-menu-item"><button class="room-menu-button"
                                             :class="{
                                               selected: roomMode === 'doc',
                                               disabled: isRoomModeExam || !isOpener() && isParticipantRole(),
                                             }"
                                             v-tooltip.right="$t('common.doc')"
                                             @click="onClickMenu('doc')">
            <GrmIcon icon="menu-docshare-white" size="full" />
          </button>
          </li>
          <li v-if="useMediaShare"
              class="room-menu-item"><button class="room-menu-button"
                                             :class="{
                                               selected: roomMode === 'media',
                                               disabled: isRoomModeExam || !isOpener() && isParticipantRole(),
                                             }"
                                             v-tooltip.right="$t('common.mediaShare')"
                                             @click="onClickMenu('media')">
            <GrmIcon icon="menu-mediashare-white" size="full" />
          </button>
          </li>
          <li v-if="useMirroring" class="room-menu-item">
            <button class="room-menu-button"
                    :class="{
                      selected: roomMode === 'mirroring',
                      disabled: isRoomModeExam || !isOpener() && isParticipantRole()
                    }"
                    v-tooltip.right="$t('common.mirroring')"
                    @click="onClickMenu('mirroring')"
            ><GrmIcon icon="menu-docshare-white" size="full" /></button>
          </li>
          <li v-if="useMeetingNote"
              class="room-menu-item "><button class="room-menu-button"
                                              :class="{
                                               disabled: isRoomModeExam || !isOpener() && isParticipantRole(),
                                             }"
                                              v-tooltip.right="$t('common.meetingNote')"
                                              @click="onToggleMeetingNote">
            <GrmIcon :icon="`menu-meeting-note-${ isOngoingMeetingNote ? 'on':'off'}`" size="full" />
          </button>
          </li>
          <li v-if="useExam"
              class="room-menu-item"><button class="room-menu-button exam"
                                             :class="{
                                               selected: isRoomModeExam,
                                               disabled: !isOpener() && isParticipantRole(),
                                             }"
                                             v-tooltip.right="$t('common.exam')"
                                             @click="onToggleExamModal"></button>
          </li>
          <li v-if="useCbt"
              class="room-menu-item"><button class="room-menu-button exam"
                                             :class="{
                                               selected: roomMode === 'CBT',
                                               disabled: !isOpener() && isParticipantRole(),
                                             }"
                                             v-tooltip.right="$t('common.CBT')"
                                             @click="onToggleCBTModal"></button>
          </li>
          <li v-if="useSticker"
              class="room-menu-item"><button class="room-menu-button sticker"
                                             v-tooltip.right="$t('menu.sticker')"
                                             @click="$emit('update:isOpenRoomStickerModal', !isOpenRoomStickerModal)"></button>
          </li>
          <li v-if="isWebinarLive && useQnA"
              class="room-menu-item"><button class="room-menu-button qna"
                                             v-tooltip.right="$t('common.qna')"
                                             @click="onToggleQnAModal">
              <span v-if="questionList.length > 0" class="qna-count-badge qna-count">{{ questionList.length }}</span>
            </button>
          </li>
          <li v-if="useAttendanceList"
              class="room-menu-item"><button class="room-menu-button"
                                             :class="{ disabled: !isOpener() && isParticipantRole() }"
                                             v-tooltip.right="$t('common.attendance')"
                                             @click="onToggleAttendanceModal">
            <GrmIcon icon="menu-attendance-white" size="full" />
          </button>
          </li>
          <li v-if="useWaitingRoom"
              class="room-menu-item"><button class="room-menu-button"
                                             :class="{
                                               badge: unchecked,
                                               disabled: !isOpener() && isParticipantRole(),
                                             }"
                                             v-tooltip.right="$t('common.waitingRoom')"
                                             @click="onToggleWaitingModal">
            <GrmIcon icon="menu-waiting-white" size="full" />
          </button>
          </li>
          <li v-if="useAIChatBot" class="room-menu-item"><button class="room-menu-button"
                                             v-tooltip.right="$t('common.chatBot')"
                                             @click="onToggleChatBotModal">
            <GrmIcon icon="menu-chat-bot" size="full" />
          </button>
          </li>
        </ul>
      </div>
      <div class="room-menu-footer">
        <div class="exit">
          <button class="exit-button" @click="exitRoom" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

import {Device} from "@/utils";

import RoomAttendanceModal from "@/components/Room/Attendance/Modal";
import RoomWaitingModal from "@/components/Room/Waiting/Modal";
import RoomWaitingModalMobile from "@/components/Room/Waiting/ModalMobile";
import RoomMeetingNoteModal from "@/components/Room/MeetingNote/Modal.vue";
import RoomCBTModal from "@/components/Room/CBT/RoomCBTModal.vue";
import RoomQnAModal from "@/components/Room/QnA/Modal";
import {closeWindow} from "@/core/api/util.api";
import GrmIcon from "@/components/Common/icon/GrmIcon";
import Testbank from "@/components/Room/Testbank/Testbank.vue";
import RoomSettingModal from "@/components/Room/SettingRenew/Modal.vue";
import RoomChatBotModal from "@/components/Room/ChatBot/Modal.vue";

export default {
  name: 'RoomMenu',
  components: {
    GrmIcon
  },
  props: {
    isOpenExtendMenu: Boolean,
    isOpenRoomStickerModal: Boolean,
    v2CamsHomeUrl: String,
  },
  data(){
    return {
      roomTimer: '00:00:00',
      userEnterRoomBeginDiff: null,
      initTime: null,
      tmpCamStudyAttendance: '출석체크',
      showCamStudyAttendanceTxt: false
    }
  },
  computed: {
    useWaitingRoom() {
      return this.roomInfoSetting?.['useWaitingMode'];
    },
    useDocShare() {
      return this.roomInfoSetting?.['useDocShare'];
    },
    useMediaShare() {
      return this.roomInfoSetting?.['useMediaShare'];
    },
    useScreenShare() {
      return this.roomInfoSetting?.['useScreenShare'];
    },
    useExam() {
      return this.isEdu && this.roomInfoSetting?.['useExam'];
    },
    useCbt() {
      return this.roomInfoSetting?.['useCbt'];
    },
    useSticker() {
      return this.isEdu && this.roomInfoSetting?.['useSticker'];
    },
    useAttendanceList() {
      return this.roomInfoSetting?.['useAttendanceList'];
    },
    useQnA() {
      return this.roomInfoSetting?.['useQnA'];
    },
    useMeetingNote() {
      return this.roomInfoSetting?.['useMeetingNote'];
    },
    useMirroring() {
      return this.roomInfoSetting?.['useMirroring'];
    },
    useAIChatBot() {
      return this.roomInfoSetting?.['useAIChatBot'];
    },
    roomModeChangeAlert(){
      return {
        doNotShowAgain: false,
        description: this.$t('common.never'),
      }
    },
    ...mapState('ux', [
      'ux'
    ]),
    ...mapGetters('user', [
      'me',
      'isOpener',
      'hasEmceeRole',
      'isParticipantRole',
      'hasSpeakerRole',
      'getScreenShareUser',
    ]),
    ...mapGetters('room', [
      'room',
      'isEdu',
      'roomMode',
      'isRoomMode',
      'roomInfoSetting',
      'isCamStudy',
    ]),
    ...mapGetters('waitingRoom', [
      'hasWaitingUser'
    ]),
    ...mapState('waitingRoom', [
      'unchecked',
      'waitingList'
    ]),
    ...mapGetters('question', [
      'myQuestionList',
      'roomQuestionList'
    ]),
    ...mapGetters('roomSetting', [
      'roomSetting'
    ]),
    ...mapGetters('call', [
      'isWebinarLive',
    ]),
    ...mapGetters('meetingNote', [
        'isOngoingMeetingNote',
        'ongoingMeetingNote',
    ]),
    ...mapGetters('group', [
      'group'
    ]),
    waitingModalComponent() {
      return Device.isMobile() ? RoomWaitingModalMobile : RoomWaitingModal;
    },
    meetingNoteModalComponent() {
      return Device.isMobile() ? RoomMeetingNoteModal : RoomMeetingNoteModal; // mobile 용 Modal 추가 개발 필요
    },
    roomId(){
      return this.room.roomId;
    },
    Device() {
      return Device;
    },
    screenShareTooltipMsg(){
      if(!this.screenShareRole){
        return this.$t('menu.screenShare.noRole.title');
      }else{
        return this.$t('common.screenShare');
      }
    },
    screenShareRole(){
      return this.me?.roomUserRole?.screen;
    },
    questionList(){
      if(!this.roomSetting['useQnAShare'] && this.isParticipantRole()){
        return this.myQuestionList
      } else {
        return this.roomQuestionList
      }
    },
    isRoomModeExam(){
      return this.roomMode === 'exam'
    },
    isRoomModeGroup(){
      return this.roomMode === 'group'
    },
    roomModeName(){
      return roomMode => {
        let roomModeName;
        switch (roomMode || this.roomMode) {
          case 'call': roomModeName = this.$t('common.call'); break;
          case 'screenShare': roomModeName = this.$t('common.screenShare'); break;
          case 'doc': roomModeName = this.$t('common.doc'); break;
          case 'media': roomModeName = this.$t('common.mediaShare'); break;
          case 'exam': roomModeName = this.$t('common.exam'); break;
          case 'CBT': roomModeName = this.$t('common.CBT'); break;
          case 'group': roomModeName = this.$t('common.groupDiscussion'); break;
          case 'mirroring': roomModeName = this.$t('common.mirroring'); break;
          default: roomModeName = 'UNKNOWN'; break;
        }
        return roomModeName;
      }
    }
  },
  watch:{
    roomId(val) {
      if(this.isOpener() || !this.isParticipantRole()){
        this.findAllByRoomIdApi({roomId: val});
      }
    },
    waitingList(val){
      let hasList = val.length > 0
      if(this.isOpener() || !this.isParticipantRole()){
        this.SET_UNCHECKED(hasList)
      }
    }
  },
  created() {
    this.$modal(this.waitingModalComponent, { exist: true });
    this.setRoomTimer()
  },
  methods: {
    ...mapActions('room', [
        'changeRoomMode',
        'startScreenShare',
        'reqLeave'
    ]),
    ...mapActions('call', ['toggleConnectionStats']),
    ...mapMutations('waitingRoom', ['SET_UNCHECKED'],),
    ...mapActions('waitingRoom', ['findAllByRoomIdApi']),
    ...mapActions('meetingNote', [
      'startMeetingNote',
      'stopMeetingNote',
    ]),
    onClickMenu(menuType) {
      if(menuType !== 'screenShare' 
        && menuType === this.roomMode){
        return;
      }
      if(this.isRoomModeExam){
        return this.$alert({
          text: this.$t('menu.alert.exam'),
          onlyOk: true,
        })      
      }

      if(this.isRoomModeGroup) {
        return this.$alert({
          text: this.$t('menu.alert.group'),
          onlyOk: true,
        })
      }
      const lastRoomMode = this.roomMode;
      this.$emit('update:roomMode', menuType)
      switch (menuType) {
        case 'call':
          if (!this.isOpener() && this.isParticipantRole()) {
            return this.$alert(this.$t('menu.noRole.call'));
          }
          break
        case 'screenShare':
          if(this.isWebinarLive && !this.hasSpeakerRole()){
            return this.$alert(this.$t('menu.screenShare.onCall'));
          }else if(!this.screenShareRole) {
            return this.$alert(this.$t('menu.screenShare.noRole.text'));
          }else if(Device.isMobile() || Device.isTablet()){
            return this.$alert(this.$t('menu.screenShare.mobile'));
          }else if(lastRoomMode === 'screenShare'){
            const isMe = this.getScreenShareUser === this.me;
            if(!isMe){
              const {nickname} = this.getScreenShareUser;
              const THIS = this;
              return this.$alert({
                title: this.$t('menu.screenShare.quit.title'),
                text: this.$t('menu.screenShare.quit.text', { '0' : nickname }),
                ok() {
                  THIS.startScreenShare();
                }
              });              
            }
          }
          return this.startScreenShare();
        case 'doc':
          if (!this.isOpener() && this.isParticipantRole()) {
            return this.$alert(this.$t('menu.noRole.doc'));
          }
          break
        case 'media':
          if (!this.isOpener() && this.isParticipantRole()) {
            return this.$alert(this.$t('menu.noRole.media'));
          }
          break
        case 'mirroring':
          if (!this.isOpener() && this.isParticipantRole()) {
            return this.$alert(this.$t('menu.noRole.mirroring'));
          }
          break
        case 'sticker':
        case 'attendance':
        case 'exam':
          return;
        default :
          return this.$alert(this.$t('menu.notAvailable'));
      }

      // if(this.roomModeChangeAlert.doNotShowAgain){
      //   this.changeRoomMode({roomMode: menuType})
      // }else{
      //   this.$alert({
      //     title: this.$t('menu.changeMode.title', { '0' : this.roomModeName(menuType)}),
      //     text: this.$t('menu.changeMode.text', { '0' : this.roomModeName()}),
      //     type: 'checkbox',
      //     typeDescription: this.roomModeChangeAlert.description,
      //     ok: (check) => {
      //       this.roomModeChangeAlert.doNotShowAgain = check
      //       this.changeRoomMode({roomMode: menuType})
      //     },
      //   });
      // }
      this.changeRoomMode({roomMode: menuType})
    },
    exitRoom() {
      this.$alert({
        title: this.$t('menu.quit.title'),
        text: this.hasWaitingUser && this.hasEmceeRole() ? this.$t('menu.quit.hasWaitingUser') : this.$t('menu.quit.text'),
        okText: this.$t('menu.quit.title'),
        ok: () => {
          this.reqLeave();

          if (this.room.isMobileCamStudy) {
            window.location.href = this.v2CamsHomeUrl;
          } else {
            closeWindow();
          }
        }
      })
    },
    onToggleAttendanceModal() {
      if (!this.isOpener() && this.isParticipantRole()) {
        return this.$alert(this.$t('menu.noRole.attendance'));
      }
      this.$modal(RoomAttendanceModal)
    },
    onToggleWaitingModal() {
      if (!this.isOpener() && this.isParticipantRole()) {
        return this.$alert(this.$t('menu.noRole.waitingRoom'));
      }

      this.$modal(this.waitingModalComponent)
      this.SET_UNCHECKED(false)
    },
    onToggleMeetingNote() {
      if (!this.isOpener() && this.isParticipantRole()) {
        return this.$alert(this.$t('menu.noRole.meetingNote'));
      }
      this.$modal(this.meetingNoteModalComponent)
      //
      // if(this.isOngoingMeetingNote){
      //   return this.$alert({
      //     text: this.$t('extendMenu.meetingNote.quit'),
      //     ok: () => {
      //       this.stopMeetingNote(this.ongoingMeetingNote);
      //     },
      //   })
      // }else{
      //   return this.$alert({
      //     text: this.$t('extendMenu.meetingNote.start'),
      //     ok: () => {
      //       this.startMeetingNote()
      //     },
      //   })
      // }    
    },
    onToggleExamModal() {
      if (!this.isOpener() && this.isParticipantRole()) {
        return this.$alert(this.$t('menu.noRole.exam'));
      }
      this.$modal(Testbank)
    },
    onToggleCBTModal() {
      if (!this.isOpener() && this.isParticipantRole()) {
        return this.$alert(this.$t('menu.noRole.CBT'));
      }
      this.$modal(RoomCBTModal)
    },
    onToggleQnAModal(){
      this.$modal(RoomQnAModal)
    },
    onToggleSettingModal() {
      this.$modal(RoomSettingModal)
    },
    onToggleChatBotModal() {
      this.$modal(RoomChatBotModal)
    },
    setRoomTimer(){
      if(!this.userEnterRoomBeginDiff || !this.initTime) {
        this.initTimer()
      }
      if(this.userEnterRoomBeginDiff && this.initTime) {
        let time = (this.userEnterRoomBeginDiff + (Date.now() - this.initTime)) / 1000;
        let mark = time > 0 ? '' : '-';
        let _time = Math.abs(time);
        let h = '' + Math.min(parseInt(_time / (60*60)), 999);
        let m = '' + parseInt(_time / 60 % 60);
        let s = '' + parseInt(_time % 60);

        // this.roomTimer = mark
        if(this.$refs.roomTimer){
          this.$refs.roomTimer.innerText = mark
              + h.lpad(2, '0')
              + ':' + m.lpad(2, '0')
              + ':' + s.lpad(2, '0');
        }
      }
      setTimeout(this.setRoomTimer, 1000);
    },
    initTimer() {
      if(this.room && this.room.beginDate && this.me && this.me.enterDate) {
        this.userEnterRoomBeginDiff = new Date(this.me.enterDate).getTime() - new Date(this.room.beginDate).getTime()
        this.initTime = Date.now()
      }
    },
  }
}

</script>

<style lang="scss" scoped>
.room-menu-component {
  height: 100%;
}
.room-menu {
  height: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.2);
}
.room-menu-header {
  height: 50px;
}
.setting {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.setting-button {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  &::before {
    content: '';
    width: 24px;
    height: 24px;
    border-radius: 100%;
    background: rgba(0, 0, 0, 0.6) url('~@/assets/images/setting_white.svg') no-repeat center / 12px auto;
    position: absolute;
    transform: translate(12px, 6px);
    opacity: 0;
    visibility: hidden;
    transition: 0.1s ease-out;
  }
  &:hover {
    &::before {
      opacity: 1;
      visibility: visible;
    }
  }
}
.room-menu-body {
  min-height: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.timer {
  background-color: rgba(0, 0, 0, 0.6);
  text-align: center;
}
.timer-text {
  font-size: 12px;
  color: #fff;
  line-height: 30px;
  display: block;
  cursor: default;
}
.room-menu-list {
  min-height: 0;
  flex: 1;
}
.room-menu-item {}
.room-menu-button {
  width: 100%;
  height: 50px;
  position: relative;
  transition: 0.1s ease-out;
  &.badge {
    &::before {
      content: '';
      width: 10px;
      height: 10px;
      border-radius: 100%;
      background: linear-gradient(135deg, #f01, #f09);
      position: absolute;
      top: 10px;
      right: 12px;
    }
  }
  &.exam {
    background: url('~@/assets/images/exam_white.svg') no-repeat center / 22px auto;
  }
  &.sticker {
    background: url('~@/assets/images/smile_white.svg') no-repeat center / 22px auto;
  }
  &.qna {
    background: url('~@/assets/images/qna_white.svg') no-repeat center / 24px auto;
    .qna-count-badge{
      position: absolute;
      right: 10px;
      top: 10px;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background-color: red;
      color: #fff;
      text-align: center;
      font-size: 10px;
      font-weight: 500;
      line-height: 2;
      letter-spacing: 0;
    }
  }
  &.selected {
    background-color: rgba(0, 0, 0, 0.4);
  }
  &:hover {
    background-color: rgba(0, 0, 0, 0.6);
  }
  &.disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
}
.room-menu-footer {}
.exit {
  height: 60px;
}
.exit-button {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  position: relative;
  overflow: hidden;
  transition: 0.2s ease-out;
  &::before,
  &::after {
    content: '';
    width: 100%;
    height: 100%;
    background: url('~@/assets/images/exit_white.svg') no-repeat center / 28px auto;
    position: absolute;
    top: 0;
    transition: 0.2s ease-out;
  }
  &::before {
    right: 0;
  }
  &::after {
    right: -100%;
  }
  &:hover {
    background-color: #f05;
    &::before {
      right: 100%;
    }
    &::after {
      right: 0;
    }
  }
}
.chat-bot {
  height: 60px;
}
.chat-bot-button {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  position: relative;
  overflow: hidden;
  transition: 0.2s ease-out;
  &::before,
  &::after {
    content: '';
    width: 100%;
    height: 100%;
    background: url('~@/assets/images/chatbot_white.png') no-repeat center / 28px auto;
    position: absolute;
    top: 0;
    transition: 0.2s ease-out;
  }
  &::before {
    right: 0;
  }
  &::after {
    right: -100%;
  }
  &:hover {
    background-color: #f05;
    &::before {
      right: 100%;
    }
    &::after {
      right: 0;
    }
  }
}

[grm-device-mobile] {
  .room-menu-component {
    position: absolute;
    transition: 0.3s ease-out;
    &.hide {
      transform: translateX(-100%);
    }
  }
  .room-menu-list {
    overflow-y: auto;
  }
}
</style>